import { createContext } from "react";

/** How many stacked sheets are ancestors of the current tree. 0 means the base sheet layer. */
export const SheetLayerContext = createContext(0);
